export default __webpack_public_path__ + "static/AT&T-0d39aa1dbb10828e9fcbe82fc56a0d77.svg";